import React, { useContext, useEffect, useRef, useState, Fragment } from 'react'
import { useHistory, useParams } from 'react-router';
import { authContext } from '../../context/AuthContext'

import Loading from "../helper/Loading"
import CenterButtonWithHeader, {CenterButtonWithAffidative} from '../helper/CenterButtonWithHeader';
import scorm_api from '../../hooks/scormAPI';
import axios from 'axios';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import Alert from '@mui/material/Alert';

const { REACT_APP_GIBMP } = process.env;

// if saving progress as user complete slides, need to set suspend data and cmi.interactions.childArray before resuming
const Quiz = props => {
    const mounted = useRef(true)

    const userMain = useContext(authContext)
    const user = userMain.user
    const token = userMain.accessToken

    const history = useHistory()
    const params = useParams()

    const [hyperlink, setLink] = useState(history.location.state ? history.location.state.quizSrc : null)

    const [go, setGo] = useState(false) // starts quiz
    const goRef = useRef(false) // using a ref for keeping track of quiz start for listener funcs

    const {t} = props;

    const [exited, setExited] = useState(false) // displays return button
    const exitedRef = useRef(false) // using a ref in addition to state for listener funcs

    const [loading, setLoading] = useState(true)
    //const [invalidID, setInvalidID] = useState(false) // if bad url, displays message
    const [message, setMessage] = useState(null) // if bad url, displays message

    //const [recordID, setRecordID] = useState(null)
    const recordIDRef = useRef(null)

    const courseID = params.id
    const trainingId = history.location.state ? history.location.state.trainingId : null
    const needAffidative = history.location.state ? history.location.state.needAffidative : false

    const headers = {
        headers: {
            'Authorization': token
        }
    }

    console.log("Location state", history.location.state)

    async function initLoad() {
        if (!history.location.state)
             setMessage(t('Quiz.InvalidCourseId'))
        // if the hyperlink is undefined, grab it
        if (hyperlink === null || hyperlink === "" || hyperlink === undefined) {
            let tempLink = null
            let tempInvalid = false

            // check if the courseID exists in the system
            console.log("Hyperlink not found, Getting hyperlink")
            const res = await axios.get('/api/course/' + courseID)

            // if the course exists, then set the hyperlink to the given one
            if (res.data.course) {
                tempLink = res.data.course.postTestLink

                // check if the link is defined on the course thing
                if (tempLink === null || tempLink === "" || tempLink === undefined) tempInvalid = true

                // if it doesn't, then display an error
            } else 
                tempInvalid = true

            if (mounted.current) {
                if (tempInvalid) 
                    setMessage(t('Quiz.InvalidCourseId'))
                setLink(tempLink)
            }
        }


        scorm_api()

        // window.API_1484_11.apiLogLevel = 2; // Log everything (Info)
        window.API_1484_11.apiLogLevel = 2;

        // mount update hooks 
        window.API_1484_11.on("SetValue.cmi.suspend_data", onSaveProgress);
        window.API_1484_11.on("Terminate", onExit);

        setLoading(false)
    }

    useEffect(() => {

        initLoad()

        return () => {
            console.log("exited: " + exited);
            console.log("exitedRef: " + exitedRef.current)
            console.log("goRef: " + goRef.current)
            // only save if users has not exit LMS, and abruptly unmount caused with back button
            if (exitedRef.current === false && goRef.current === true) { 
                console.log("Unmount save")
                onSave()
            }
            console.log("UnMounted SCORM")
            window.API_1484_11.reset()
            mounted.current = false
            goRef.current = false
            recordIDRef.current = null
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    //listeners
    useEffect(() => {
        const onWindowClose = (ev) => {
            if (exitedRef.current === false && goRef.current === true) {
                ev.preventDefault();
                console.log("onWindowClose Listener called")
                console.log(ev);
                 // unable to set this, it will jsut say Confirm Leave
                ev.returnValue =  "Test will not be saved. At end of test, click Finish button.";
                return ev.returnValue
            }
        }

        const afterWindowClose = async (ev) => {
            if (exitedRef.current === false && goRef.current === true) {
                ev.preventDefault();
                console.log("afterWindowClose Listener called")
               
                // only save if users has not exit LMS, and abruptly close window
                if (exited === false) { 
                    console.log("afterWindowClose save")
                    await onSave()
                }
            }
        }

        console.log("Adding listeners")
        window.addEventListener("beforeunload", onWindowClose);
        //adding unload handler since if users close window, our useEffect unmount doesn't get called.
        window.addEventListener("unload", afterWindowClose);

        const historyBlock = history.block(() => {
            console.log("history block LIstener CALLED")
            if (exitedRef.current===false && goRef.current===true) 
                return 'Test will not be saved. At end of test, click Finish button.';
        });

        return () => {
            console.log("Removing listeners")
            window.removeEventListener("beforeunload", onWindowClose)
            window.removeEventListener("unload", afterWindowClose)
            historyBlock()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const onGo = async () => {

        // create test record and save id
        const res = await axios.post('/api/test', {
            courseId: courseID,
            score: 0, // initial score is 0
            student_id: user.username,
            byUsername: user.username,
            notes: null,
            trainingId: trainingId
        })

        console.log(res)

        //TODO: check the return code from axios, and give out error and not set id if there is server error..
        const id = res.data.id

        console.log("ID: " + id)
        console.log("mounted:" + mounted.current)
        if (id !== undefined) {
            if (mounted.current) {
                //setRecordID(id)
                setGo(true)
                goRef.current = true;
                recordIDRef.current = id
            }

        } else {
            setMessage("no test score id, this should not happen. res = " + res)
        }
        
    }

    // called when setValue i.e. when each answer is submitted
    const onSaveProgress = async () => {
        //console.log(go)
        console.log("OnSaveProgress Record ID Ref: " + recordIDRef.current)
        if (goRef.current === true) {
            const data = window.API_1484_11.cmi.toJSON()

            const score = data.score.raw
            const testStatus = score >= 75 ? "Passed" : null


            console.log("SAVING Quiz Progress: ", user.username, score, testStatus, recordIDRef.current)
            const res = await axios.post('/api/test/progress/' + recordIDRef.current, {
                score,
                testStatus,
                //endDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                byUsername: user.username,
            });
        } else
            setMessage("onSaveProgress called, but haven't started test -> not saved")
    }

   // save test progress, score (send email if passed certificate test), and questions/answers
    const onSave = async () => {
        //console.log(go)
        console.log("OnSave Record ID Ref: " + recordIDRef.current)
        if (goRef.current === true) {
            const data = window.API_1484_11.cmi.toJSON()

            const score = data.score.raw
            const statusDone = data.completion_status
            const statusPass = data.success_status
            const suspend = data.suspend_data
            const questions = data.interactions.childArray

            const status = (statusPass === "passed") ? "passed" : statusDone
            const testStatus = score >= 75 ? "Passed" : "Failed"

            console.log("Saving Quiz Complete: ", trainingId, needAffidative, score, status, statusDone, statusPass, courseID, user.username, recordIDRef.current, questions)
            await axios.all([
                axios.post('/api/courseProgress/progress', {
                    COURSEID: courseID,
                    username: user.username,
                    trainingId: trainingId,
                    // if the status is not passed, leaves the field undefined to avoid changing the existing status
                    STATUS: status === "passed" ? "passed" : undefined
                }, headers),
                axios.post('/api/test/' + recordIDRef.current, {
                    score,
                    testStatus,
                    scormSuspendData: status === "passed" ? suspend : null,
                    //endDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                    byUsername: user.username,
                    isDisgarded: null,
                    notes: null,
                    isCertTest: needAffidative
                }),
                axios.post('/api/test/detail/' + recordIDRef.current, {
                    questions,
                })
            ])
        } else
            setMessage("onSave called, but haven't started quiz/test -> not saved")
    }

    const onExit = () => {
        console.log("onExit")
        onSave()

        // this opens the next button and begins saving the score in the background
        // using useEffect here allows state variables to be used with the hook (instead of moving the code in the useEffect to here)
        setExited(true)
        exitedRef.current = true;
    }

    const onReturn = () => {
        // with articulate doing goBack then pushing to quiz, I can use goBack to return to the main page
        if (history.location.state.fromVideo === false) 
            history.goBack()
        else 
            history.go(-2)
    }

    const src =  REACT_APP_GIBMP + hyperlink

    return (
        <>
            <Fragment>
            {message &&
            <div>
                <Alert severity="error">{message}</Alert>
            </div>
            }
            {
                loading ? <Loading /> :
                    exited ? <CenterButtonWithHeader title={t('Quiz.ReturnMainPage')} text={t('Quiz.Return')} onClick={onReturn} /> :
                        go ? <iframe title={t('Quiz.QuizWindow')} src={src} width='1024' height='500'></iframe> :
                        !needAffidative ? 
                            <CenterButtonWithHeader title={t('Quiz.StartThePostQuiz')} text={t('Quiz.BeginPostQuiz')} onClick={onGo} /> :
                            <CenterButtonWithAffidative title={t('Quiz.StartTheCertTest')} text={t('Quiz.BeginCertTest')} 
                            affidativeHeader={t('Quiz.AffidativeHeader')} affidativeItems={[t('Quiz.AffidativeItem1'), t('Quiz.AffidativeItem2'),t('Quiz.AffidativeItem3'),t('Quiz.AffidativeItem4'),t('Quiz.AffidativeItem5')]}
                            affidativeSign={t('Quiz.AffidativeSign')} onClick={onGo} /> 

            }
            </Fragment>
        </>
    )
}

export default withTranslation()(Quiz);